const Mapbox = (($) => {
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Mapbox {
    constructor(element, config) {
      this._element = element;
      this._map = null;
      this._markers = [];
      this._infoWindow = null;
      this._listeners = [];
      this._infoWindow = null;

      mapboxgl.accessToken =
        "pk.eyJ1Ijoia29odmEiLCJhIjoiY2prbDlsNXhuMXl6YzNxbnhtY2w0NzB3bSJ9.jpQllFfzX4I6lT3VF6ZByQ";
    }

    // Getters

    static get VERSION() {
      return VERSION;
    }

    show(callback) {
      if (this._element) {
        this._renderMap();
        if (callback) {
          callback(this._map);
        }
      }
    }

    resize() {
      if (this._map) {
        this._map.resize();
      }
    }

    addMarker(lat, lng, title) {
      let latLng = { lat: lat, lng: lng };

      const marker = new mapboxgl.Marker()
        .setLngLat([lng, lat])
        .addTo(this._map);

      this._markers.push(marker);

      return marker;
    }

    openInfoWindowOnMarker(contentContainer, marker) {
      if (!this._infoWindow) {
        this._infoWindow = new mapboxgl.Popup({
          closeOnClick: false,
          closeButton: true,
          offset: 25,
        });
      }

      this._infoWindow.setDOMContent(contentContainer);
      this._infoWindow.setLngLat(marker.getLngLat());
      this._infoWindow.addTo(this._map);
    }

    onBoundsChange(callback) {
      if (this._map) {
        this._map.on("moveend", (e) => {
          callback(e);
        });
      }
    }

    onIdle(callback) {
      if (this._map) {
        this._map.on("idle", (e) => {
          callback(e);
        });
      }
    }

    clearMarkers() {
      this._markers.forEach(function (marker) {
        marker.remove();
      });

      this._markers = [];
    }

    getMapInfo() {
      if (!this._map) {
        return;
      }

      let bounds = this._map.getBounds();
      let neBoundary = bounds.getNorthEast();
      let swBoundary = bounds.getSouthWest();
      let center = this._map.getCenter();
      let zoom = this._map.getZoom();

      return {
        minLat: swBoundary.lat,
        maxLat: neBoundary.lat,
        minLon: swBoundary.lng,
        maxLon: neBoundary.lng,
        centerLat: center.lat,
        centerLng: center.lng,
        zoom: zoom,
        cache: false,
      };
    }

    // Private
    _renderMap() {
      let $element = $(this._element);
      let lat = null;
      let lng = null;
      let zoom = null;
      let defaultLat = null;
      let defaultLng = null;

      defaultLat = $element.data("defaultLat") || -34.397;
      defaultLng = $element.data("defaultLng") || 150.644;

      lat = $element.data("lat") || defaultLat;
      lng = $element.data("lng") || defaultLng;
      zoom = $element.data("zoom") || 8;

      this._map = new mapboxgl.Map({
        container: this._element,
        style: "mapbox://styles/mapbox/streets-v12", // style URL
        center: [lng, lat], // starting position [lng, lat]
        zoom: zoom, // starting zoom
      });
      this._map.addControl(new mapboxgl.NavigationControl());
      this._map.scrollZoom.disable(); // Disable Scroll Zoom
      this._popout = new mapboxgl.Popup({ offset: 25 });

      this._map.on("load", () => {
        this._map.resize();
      });

      // Fix for when the map doesn't seem to be sizing to the container?
    }

    // static loadMapbox(callback) {
    //   if (!Map.googleMaps) {
    //     if (!window.google || !window.google.maps) {
    //       if (!Map.googleMapListeners) {
    //         Map.googleMapListeners = [];
    //       }
    //       Map.googleMapListeners.push(callback);

    //       let tag = document.createElement("script");
    //       tag.src =
    //         "https://maps.googleapis.com/maps/api/js?key=AIzaSyBOwigZ96jQoEOmJz_soxC-FuThsWo71KA&callback=_rvInitMap";
    //       document.body.appendChild(tag);
    //     } else {
    //       Map.googleMaps = google.maps;
    //       callback(Map.googleMaps);
    //     }
    //   } else {
    //     callback(Map.googleMaps);
    //   }
    // }
  }

  return Mapbox;
})($);

export default Mapbox;
